import React, { Suspense, useEffect, useMemo, useRef, useState } from "react";
import { ApproveCriteriaData } from "./data/ApproveCriteria.data";
import DataLoader from "../../../components/ui/dataLoader/DataLoader";
import Accordion from "../../../components/Accordion/Accordion";
import FormCreator from "../../../components/Forms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import { useNavigate, useParams } from "react-router-dom";
import {useApproveSGBPCriteriaByIdMutation,useDDownloadProductCertificationAssessmentCritreriaMutation,useGetAllRequirementListForSectionAMutation,useGetAllRequirementListForSectionBMutation,useGetAllRequirementListForSectionCMutation,useLazyGetAllDropdownForCRUDCategoryQuery,useLazyGetMinimumCriteriaForServiceByIdQuery,useLazyGetSGBPCriteriaDetailsByIdQuery,useSaveMinimumCriteriaForServiceMutation,useUpdateCriteriaDetailsMutation,} from "../../../app/services/Crud/crudApi";
import { decryptAESID } from "../../../utils/Encryption";
import { getAuthProps } from "../../../lib/authenticationLibrary";
import SwalAlert from "../../../services/swalService/SwalService";
import { setAllDropDownField } from "./utils/dropdownUtils";
import { saveAs } from "file-saver";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
const CHANNEL_PRODUCT = "1";
const CHANNEL_SERVICE = "2";

const SortableItem = ({ item, section, toggleSelect }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
  };

  return (
    <li ref={setNodeRef} style={style}>
      <input
        type="checkbox"
        checked={item.selected || false}
        onChange={() => toggleSelect(section, "assigned", item.id)}
      />
      <span>{item.name}</span>
      <span
        {...attributes}
        {...listeners}
        style={{ cursor: "grab", marginLeft: "auto", padding: "0 8px" }}
      >
        ☰
      </span>
    </li>
  );
};

const Section = ({
  sectionKey,
  displayTitle,
  data,
  searchText,
  handleSearch,
  renderList,
  listRefs,
  handleAssign,
  handleUnassign,
  handleDragEnd,
  toggleSelect,
}) => {
  const assignedList = data?.assigned || [];
  const approvedSearch = searchText[sectionKey]?.approved || "";
  const assignedSearch = (searchText[sectionKey]?.assigned || "").toLowerCase();

  return (
    <div className="requirement-section">
      <div className="req-box">
        <h4 className="section-title">{displayTitle}</h4>
        <p className="sub-title">Approved Requirements</p>
        <div className="list-box">
          <input
            type="text"
            placeholder="Search"
            className="search"
            value={approvedSearch}
            onChange={(e) => handleSearch(sectionKey, "approved", e.target.value)}
          />
          <ul
            ref={(el) => {
              if (el) listRefs.current[`${sectionKey}-approved`] = el;
              else delete listRefs.current[`${sectionKey}-approved`];
            }}
          >
            {renderList(sectionKey, "approved", data?.approved)}
          </ul>
        </div>
      </div>

      <div className="action-buttons">
        <Buttons buttonText="Assign ›" buttonTypeClassName="assign-btn" onClick={() => handleAssign(sectionKey)} />
        <Buttons buttonText="‹ Unassign" buttonTypeClassName="unassign-btn" onClick={() => handleUnassign(sectionKey)} />
      </div>

      <div className="req-box">
        <h4 className="count">Count: {assignedList.length}</h4>
        <p className="sub-title">Assigned Requirements</p>
        <div className="list-box">
          <input
            type="text"
            placeholder="Search"
            className="search"
            value={searchText[sectionKey]?.assigned || ""}
            onChange={(e) => handleSearch(sectionKey, "assigned", e.target.value)}
          />
          <DndContext
            collisionDetection={closestCenter}
            onDragEnd={(event) => handleDragEnd(sectionKey, event)}
            modifiers={[restrictToVerticalAxis]}
          >
            <SortableContext items={assignedList.map((x) => x.id)} strategy={verticalListSortingStrategy}>
              <ul
                ref={(el) => {
                  if (el) listRefs.current[`${sectionKey}-assigned`] = el;
                  else delete listRefs.current[`${sectionKey}-assigned`];
                }}
              >
                {assignedList
                  .filter((item) => item.name?.toLowerCase().includes(assignedSearch))
                  .map((item) => (
                    <SortableItem key={item.id} item={item} section={sectionKey} toggleSelect={toggleSelect} />
                  ))}
              </ul>
            </SortableContext>
          </DndContext>
        </div>
      </div>
    </div>
  );
};

// ---------------------------------------------------------------------------
// ProductCriteriaPanel: Section A, Section B, Section C + 4-tick rating panel.
// ---------------------------------------------------------------------------
const ProductCriteriaPanel = ({
  sections,
  searchText,
  handleSearch,
  renderList,
  listRefs,
  handleAssign,
  handleUnassign,
  handleDragEnd,
  toggleSelect,
  productRatings,
  productRatingMaxCount,
  onProductRatingChange,
}) => (
  <>
    <div className="requirements-page">
      {["Section A", "Section B", "Section C"].map((sectionKey) => (
        <Section
          key={sectionKey}
          sectionKey={sectionKey}
          displayTitle={sectionKey}
          data={sections[sectionKey]}
          searchText={searchText}
          handleSearch={handleSearch}
          renderList={renderList}
          listRefs={listRefs}
          handleAssign={handleAssign}
          handleUnassign={handleUnassign}
          handleDragEnd={handleDragEnd}
          toggleSelect={toggleSelect}
        />
      ))}
    </div>

    <div className="sectionC-info">
      <div className="sectionC-header">
        <h3>Section C Additional Information</h3>
      </div>
      <div className="rating-container">
        <p className="rating-title">Rating</p>
        {[1, 2, 3, 4].map((tick) => (
          <div className="rating-row" key={tick}>
            <span className="rating-label">{tick} Tick</span>
            <input
              type="text"
              className="rating-input"
              value={productRatingMaxCount === 0 ? "" : productRatings[tick]}
              onChange={(e) => onProductRatingChange(tick, e.target.value)}
            />
            <span className="rating-total">/{productRatingMaxCount || "N.A"}</span>
          </div>
        ))}
      </div>
    </div>
  </>
);

const ServiceCriteriaPanel = ({
  sections,
  searchText,
  handleSearch,
  renderList,
  listRefs,
  handleAssign,
  handleUnassign,
  handleDragEnd,
  toggleSelect,
  serviceMinCriteria,
  serviceMinCriteriaMaxCount,
  onServiceMinCriteriaChange,
}) => (
  <>
    <div className="requirements-page">
      <Section
        sectionKey="Section A"
        displayTitle="Section 1"
        data={sections["Section A"]}
        searchText={searchText}
        handleSearch={handleSearch}
        renderList={renderList}
        listRefs={listRefs}
        handleAssign={handleAssign}
        handleUnassign={handleUnassign}
        handleDragEnd={handleDragEnd}
        toggleSelect={toggleSelect}
      />
      <Section
        sectionKey="Section B"
        displayTitle="Section 2"
        data={sections["Section B"]}
        searchText={searchText}
        handleSearch={handleSearch}
        renderList={renderList}
        listRefs={listRefs}
        handleAssign={handleAssign}
        handleUnassign={handleUnassign}
        handleDragEnd={handleDragEnd}
        toggleSelect={toggleSelect}
      />
    </div>

    <div className="sectionC-info">
      <div className="sectionC-header">
        <h3>Section 2 Minimum Criteria: <input
          type="text"
          className="rating-input"
          value={serviceMinCriteria}
          onChange={(e) => onServiceMinCriteriaChange(e.target.value)}
        />
          <span className="rating-total">/{serviceMinCriteriaMaxCount || "N.A"}</span></h3>
      </div>
    </div>
  </>
);

const ApproveCriteria = () => {
  const navigate = useNavigate();
  const approveCriteriaRefs = useRef();
  const { id } = useParams();
  const editID = useMemo(() => (id ? decryptAESID(id, false) : 0), [id]);
  const [formData] = useState(ApproveCriteriaData);
  const [channel, setChannel] = useState(null);
  const { success, error } = SwalAlert();
  const [getAllRequirementListForSectionA] = useGetAllRequirementListForSectionAMutation();
  const [getAllRequirementListForSectionB] = useGetAllRequirementListForSectionBMutation();
  const [getAllRequirementListForSectionC] = useGetAllRequirementListForSectionCMutation();
  const [getDropdowns, { data: dropdownData, isLoading: dropdownLoading }] = useLazyGetAllDropdownForCRUDCategoryQuery();
  const [getSGBPCriteriaDetails, { data: criteriaDetails, isLoading: criteriaDetailsLoading }] = useLazyGetSGBPCriteriaDetailsByIdQuery();
  const [approveSGBPCriteria, { data: approveSGBPCriteriaData, isLoading: approveSGBPCriteriaIsLoading }] = useApproveSGBPCriteriaByIdMutation();
  const [submitCriteria, { data: criteriaData, isLoading: criteriaLoading }] = useUpdateCriteriaDetailsMutation();
  const [getMinimumCriteriaForService, { data: minimumCriteria, isLoading: minimumCriteriaLoading }] = useLazyGetMinimumCriteriaForServiceByIdQuery();
  const [saveMinimumCriteriaForService, { data: saveMinimumCriteriaData, isLoading: saveMinimumCriteriaLoading }] = useSaveMinimumCriteriaForServiceMutation();

  const [downloadProductCertification, { isLoading: downloadProductCertificationLoading }] = useDDownloadProductCertificationAssessmentCritreriaMutation();
  const listRefs = useRef({});
  const scrollPositions = useRef({});

  // true only once a channel is actually loaded/selected as Service ("2").
  const isServiceChannel = channel !== null && channel !== undefined && String(channel) === CHANNEL_SERVICE;

  const preserveScroll = (key, callback) => {
    const el = listRefs.current[key];
    const scrollTop = el?.scrollTop || 0;
    callback();
    setTimeout(() => {
      if (listRefs.current[key]) {
        listRefs.current[key].scrollTop = scrollTop;
      }
    }, 0);
  };

  const [sections, setSections] = useState({
    "Section A": { approved: [], assigned: [] },
    "Section B": { approved: [], assigned: [] },
    "Section C": { approved: [], assigned: [] },
  });

  const [searchText, setSearchText] = useState({
    "Section A": { approved: "", assigned: "" },
    "Section B": { approved: "", assigned: "" },
    "Section C": { approved: "", assigned: "" },
  });

  // Product-only: 4-tick rating panel.
  const [productRatings, setProductRatings] = useState({ 1: 0, 2: 0, 3: 0, 4: 0 });

  // Service-only: single "Section 2 Minimum Criteria" value.
  const [serviceMinCriteria, setServiceMinCriteria] = useState(0);

  useEffect(() => {
    getDropdowns();
  }, []);

  useEffect(() => {
    if (id) {
      getSGBPCriteriaDetails(editID);
    }
  }, [id]);

  useEffect(() => {
    if (!criteriaDetailsLoading && criteriaDetails) {
      const requirementList = criteriaDetails?.requirementList || [];
      const initialData = ApproveCriteriaData.initialState;
      initialData.channel = criteriaDetails?.channelId || criteriaDetails?.channelId?.value;
      initialData.criteriaName = criteriaDetails?.criteriaName || null;

      const channelValue = criteriaDetails?.channelId;
      const isServiceFromDetails = String(channelValue) === CHANNEL_SERVICE;

      const sectionAIds = requirementList.filter((x) => x.sectionId === 1).map((x) => x.sgbpRequirementId);
      const sectionBIds = requirementList.filter((x) => x.sectionId === 2).map((x) => x.sgbpRequirementId);
      const sectionCIds = requirementList.filter((x) => x.sectionId === 3).map((x) => x.sgbpRequirementId);

      const buildOrderMap = (sectionId) =>
        requirementList
          .filter((x) => x.sectionId === sectionId)
          .reduce((acc, x) => {
            acc[x.sgbpRequirementId] = x.valueOrdering;
            return acc;
          }, {});

      const orderMapA = buildOrderMap(1);
      const orderMapB = buildOrderMap(2);
      const orderMapC = buildOrderMap(3);

      setChannel(channelValue);
      fetchSectionA("", channelValue, sectionAIds, orderMapA);
      fetchSectionB("", channelValue, sectionBIds, orderMapB);

      if (isServiceFromDetails) {
        getMinimumCriteriaForService(editID);
        setProductRatings({ 1: 0, 2: 0, 3: 0, 4: 0 });
      } else {
        fetchSectionC("", channelValue, sectionCIds, orderMapC);
        setProductRatings({
          1: criteriaDetails?.rating1Tick ?? 0,
          2: criteriaDetails?.rating2Tick ?? 0,
          3: criteriaDetails?.rating3Tick ?? 0,
          4: criteriaDetails?.rating4Tick ?? 0,
        });
        // setServiceMinCriteria(0);
      }
    }
  }, [criteriaDetailsLoading, criteriaDetails]);

  useEffect(() => {
    if (!minimumCriteriaLoading && minimumCriteria) {
      setServiceMinCriteria(Number(minimumCriteria?.minimumCriteria) || 0);
    }
  }, [minimumCriteriaLoading, minimumCriteria]);

  useEffect(() => {
    if (!dropdownLoading && dropdownData) {
      setAllDropDownField(dropdownData);
    }
  }, [dropdownLoading, dropdownData]);

  useEffect(() => {
    if (!approveSGBPCriteriaIsLoading && approveSGBPCriteriaData) {
      success("Criteria information approve successfully");
      navigate("/criteriaApproval");
    }
  }, [approveSGBPCriteriaIsLoading, approveSGBPCriteriaData]);

  useEffect(() => {
    if (!criteriaLoading && criteriaData) {
      if (criteriaData?.errorMessage === "Criteria Name Already Exists.") {
        error("Criteria name already exists.");
      } else {
        if (isServiceChannel) {
          handleSaveMinimumCriteria();
          return;
        }
        success("Criteria information submitted successfully");
        navigate("/criteriaApproval");
      }
    }
  }, [criteriaLoading, criteriaData]);

  useEffect(() => {
    if (!saveMinimumCriteriaLoading && saveMinimumCriteriaData) {
      success("Criteria information submitted successfully");
      navigate("/criteriaApproval");
    }
  }, [saveMinimumCriteriaLoading, saveMinimumCriteriaData]);

  const handleSaveMinimumCriteria = () => {
    const req = {
      SGBPCriteriaId: editID,
      MinimumCriteria: Number(serviceMinCriteria),
    };
    saveMinimumCriteriaForService(req);
  };

  const fetchSection = (apiCall, section, search, channelId, selectedIds = [], orderMap = {}) => {
    apiCall({ RequirementName: search, channelId: channelId })
      .unwrap()
      .then((response) => {
        const approvedItems = (response || []).map((item) => ({
          id: item?.sgbpRequirementId,
          name: item?.requirementName,
          selected: false,
        }));
        setSections((prev) => {
          const assigned =
            prev[section]?.assigned?.length > 0
              ? prev[section].assigned
              : approvedItems
                .filter((item) => selectedIds?.some((sid) => Number(sid) === Number(item.id)))
                .sort((a, b) => (orderMap[a.id] ?? 0) - (orderMap[b.id] ?? 0))
                .map((item, index) => ({
                  ...item,
                  valueOrdering: orderMap[item.id] ?? index + 1,
                }));

          const approved = approvedItems.filter((item) => !assigned.some((x) => Number(x.id) === Number(item.id)));

          return {
            ...prev,
            [section]: { approved, assigned },
          };
        });
      })
      .catch((err) => console.error(err));
  };

  const fetchSectionA = (search, channelId, selectedIds = [], orderMap = {}) =>
    fetchSection(getAllRequirementListForSectionA, "Section A", search, channelId, selectedIds, orderMap);
  const fetchSectionB = (search, channelId, selectedIds = [], orderMap = {}) =>
    fetchSection(getAllRequirementListForSectionB, "Section B", search, channelId, selectedIds, orderMap);
  const fetchSectionC = (search, channelId, selectedIds = [], orderMap = {}) =>
    fetchSection(getAllRequirementListForSectionC, "Section C", search, channelId, selectedIds, orderMap);

  const handleSearch = (section, type, value) => {
    setSearchText((prev) => ({
      ...prev,
      [section]: { ...prev[section], [type]: value },
    }));

    if (type === "approved") {
      if (section === "Section A") fetchSectionA(value, channel);
      if (section === "Section B") fetchSectionB(value, channel);
      if (section === "Section C" && !isServiceChannel) fetchSectionC(value, channel);
    }
  };

  const handleAssign = (section) => {
    const key = `${section}-approved`;
    preserveScroll(key, () => {
      const approved = [...sections[section].approved];
      const assigned = [...sections[section].assigned];
      const toAssign = approved.filter((item) => item.selected);
      if (!toAssign.length) return;
      const newApproved = approved.filter((item) => !item.selected);
      const newAssigned = [...assigned, ...toAssign.map((i) => ({ ...i, selected: false }))].map((item, index) => ({
        ...item,
        valueOrdering: index + 1,
      }));
      setSections((prev) => ({
        ...prev,
        [section]: { approved: newApproved, assigned: newAssigned },
      }));
    });
  };

  const handleUnassign = (section) => {
    const key = `${section}-assigned`;
    preserveScroll(key, () => {
      const approved = [...sections[section].approved];
      const assigned = [...sections[section].assigned];
      const toUnassign = assigned.filter((item) => item.selected);
      if (!toUnassign.length) return;
      const newAssigned = assigned.filter((item) => !item.selected).map((item, index) => ({ ...item, valueOrdering: index + 1 }));
      const newApproved = [...toUnassign.map((i) => ({ ...i, selected: false })), ...approved];
      setSections((prev) => ({
        ...prev,
        [section]: { approved: newApproved, assigned: newAssigned },
      }));

      if (section === "Section C") {
        setProductRatings({ 1: 0, 2: 0, 3: 0, 4: 0 });
      }
      if (section === "Section B" && isServiceChannel) {
        setServiceMinCriteria(0);
      }
    });
  };
  useEffect(() => {
    const keys = Object.keys(listRefs.current);
    const cleanups = [];

    keys.forEach((key) => {
      const el = listRefs.current[key];
      if (!el) return;
      const handleScroll = () => {
        scrollPositions.current[key] = el.scrollTop;
      };
      el.addEventListener("scroll", handleScroll);
      cleanups.push(() => el.removeEventListener("scroll", handleScroll));
    });

    return () => cleanups.forEach((cleanup) => cleanup());
  }, [sections]);

  useEffect(() => {
    Object.keys(listRefs.current).forEach((key) => {
      const el = listRefs.current[key];
      if (el && scrollPositions.current[key] !== undefined) {
        el.scrollTop = scrollPositions.current[key];
      }
    });
  });

  const toggleSelect = (section, type, id) => {
    const key = `${section}-${type}`;
    preserveScroll(key, () => {
      setSections((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [type]: prev[section][type].map((item) => (item.id === id ? { ...item, selected: !item.selected } : item)),
        },
      }));
    });
  };

  const handleSave = () => {
    const authData = getAuthProps();
    const formValues = approveCriteriaRefs.current?.getFormData();

    if (!formValues) {
      error("Please fill in all mandatory fields to continue.", "");
      return;
    }

    const requirementList = [
      ...sections["Section A"].assigned.map((item) => ({
        RequirementId: item.id,
        SectionId: 1,
        ValueOrdering: item.valueOrdering,
        UpdatedBy: 115,
        UpdatedAppId: authData?.adminUserId,
        CriteriaId: editID,
      })),
      ...sections["Section B"].assigned.map((item) => ({
        RequirementId: item.id,
        SectionId: 2,
        ValueOrdering: item.valueOrdering,
        UpdatedBy: 115,
        UpdatedAppId: authData?.adminUserId,
        CriteriaId: editID,
      })),
      // Section C only exists for Product.
      ...(isServiceChannel
        ? []
        : sections["Section C"].assigned.map((item) => ({
          RequirementId: item.id,
          SectionId: 3,
          ValueOrdering: item.valueOrdering,
          UpdatedBy: 115,
          UpdatedAppId: authData?.adminUserId,
          CriteriaId: editID,
        }))),
    ];

    const request = {
      CriteriaId: editID,
      ChannelId: formValues?.channel?.value || formValues?.channel || null,
      CriteriaName: formValues?.criteriaName || null,
      Rating1Tick: isServiceChannel ? null : Number(productRatings[1]),
      Rating2Tick: isServiceChannel ? null : Number(productRatings[2]),
      Rating3Tick: isServiceChannel ? null : Number(productRatings[3]),
      Rating4Tick: isServiceChannel ? null : Number(productRatings[4]),
      UpdateRequirementList: requirementList,
      // StatusId: 2
    };
    submitCriteria(request);
  };

  const renderList = (section, type, list) =>
    (list || []).map((item) => (
      <li key={item.id}>
        <input type="checkbox" checked={item.selected || false} onChange={() => toggleSelect(section, type, item.id)} />
        <span>{item.name}</span>
      </li>
    ));

  const productRatingMaxCount = sections?.["Section C"]?.assigned?.length ?? 0;
  const handleProductRatingChange = (tick, value) => {
    if (!/^\d*$/.test(value)) return;

    const cleanedValue = value.replace(/^0+/, "") || "0";
    const num = Number(cleanedValue);
    if (num > productRatingMaxCount) return;

    setProductRatings((prev) => {
      const updated = { ...prev, [tick]: num };
      for (let i = 2; i <= 4; i++) {
        if (updated[i] !== 0 && updated[i] <= updated[i - 1]) {
          return prev;
        }
      }
      return updated;
    });
  };

  const serviceMinCriteriaMaxCount = sections?.["Section B"]?.assigned?.length ?? 0;
  const handleServiceMinCriteriaChange = (value) => {
    if (!/^\d*$/.test(value)) return;
    const cleanedValue = value.replace(/^0+/, "") || "0";
    const num = Number(cleanedValue);
    if (num > serviceMinCriteriaMaxCount) return;
    setServiceMinCriteria(num);
  };

  const handleApprove = () => {
    const req = { SGBPCriteriaId: editID };
    approveSGBPCriteria(req);
  };

  const handleBack = () => {
    navigate("/criteriaApproval");
  };

  const handleDownloadPDF = async () => {
    const request = { SGBPCriteriaId: editID };
    const response = await downloadProductCertification(request);

    if (response && response.data) {
      const { fileData } = response.data;
      const blob = new Blob([fileData], { type: "application/pdf" });
      saveAs(blob, "ProductCertificate.pdf");
    }
  };

  const handleFormFieldChange = (field, value) => {
    if (field === "channel") {
      const selectedChannel = value?.value;
      setChannel(selectedChannel);

      fetchSectionA("", selectedChannel);
      fetchSectionB("", selectedChannel);

      if (String(selectedChannel) === CHANNEL_SERVICE) {
        setSections((prev) => ({
          ...prev,
          "Section C": { approved: [], assigned: [] },
        }));
        setServiceMinCriteria(0);
      } else {
        fetchSectionC("", selectedChannel);
        setProductRatings({ 1: 0, 2: 0, 3: 0, 4: 0 });
      }
    }
  };

  const handleDragEnd = (section, event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setSections((prev) => {
      const assigned = [...prev[section].assigned];
      const oldIndex = assigned.findIndex((x) => x.id === active.id);
      const newIndex = assigned.findIndex((x) => x.id === over.id);

      const reordered = arrayMove(assigned, oldIndex, newIndex).map((item, index) => ({
        ...item,
        valueOrdering: index + 1,
      }));

      return {
        ...prev,
        [section]: { ...prev[section], assigned: reordered },
      };
    });
  };

  return (
    <div className="add-requirement">
      <Suspense fallback={<DataLoader />}>
        <Accordion title="Criteria Information" className="mb-4" button={false} accordion={false}>
          <div className="row">
            <FormCreator ref={approveCriteriaRefs} {...formData} onFormFieldValueChange={handleFormFieldChange} />
          </div>

          {isServiceChannel ? (
            <ServiceCriteriaPanel
              sections={sections}
              searchText={searchText}
              handleSearch={handleSearch}
              renderList={renderList}
              listRefs={listRefs}
              handleAssign={handleAssign}
              handleUnassign={handleUnassign}
              handleDragEnd={handleDragEnd}
              toggleSelect={toggleSelect}
              serviceMinCriteria={serviceMinCriteria}
              serviceMinCriteriaMaxCount={serviceMinCriteriaMaxCount}
              onServiceMinCriteriaChange={handleServiceMinCriteriaChange}
            />
          ) : (
            <ProductCriteriaPanel
              sections={sections}
              searchText={searchText}
              handleSearch={handleSearch}
              renderList={renderList}
              listRefs={listRefs}
              handleAssign={handleAssign}
              handleUnassign={handleUnassign}
              handleDragEnd={handleDragEnd}
              toggleSelect={toggleSelect}
              productRatings={productRatings}
              productRatingMaxCount={productRatingMaxCount}
              onProductRatingChange={handleProductRatingChange}
            />
          )}
        </Accordion>

        <div className="add-criteria-btn-wrapper">
          <Buttons buttonText="Back" buttonTypeClassName="btn btn-secondary mb-2" onClick={handleBack} />
          <Buttons
            buttonText="Download PDF"
            buttonTypeClassName="orange-btn"
            onClick={handleDownloadPDF}
            isDisable={criteriaDetails?.statusId !== 9 || downloadProductCertificationLoading}
            isLoading={downloadProductCertificationLoading}
          />
          <Buttons
            buttonText="Save"
            buttonTypeClassName="add-btn"
            onClick={handleSave}
            isDisable={criteriaDetails?.statusId === 9 || criteriaLoading || saveMinimumCriteriaLoading}
          />
          <Buttons
            buttonText="Approve"
            buttonTypeClassName="approve-btn"
            onClick={handleApprove}
            isDisable={criteriaDetails?.statusId === 9 || approveSGBPCriteriaIsLoading}
          />
        </div>
      </Suspense>
    </div>
  );
};

export default ApproveCriteria;
